import FadeInSection from "../../ui/fade-in-section";

export default function SessionsHero() {
  return (
    <section className="relative bg-white pt-20 sm:pt-24 pb-10 sm:pb-14 overflow-hidden">
      <div className="absolute inset-0 saas-hero-mesh" aria-hidden />
      <div
        className="absolute top-0 right-0 w-[480px] h-[480px] rounded-full bg-teal/5 blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none"
        aria-hidden
      />

      <div className="page-container relative z-10">
        <FadeInSection immediate y={20} duration={0.5}>
          <div className="max-w-3xl mx-auto text-center">
            <span className="home-eyebrow">PYCRAY Forge</span>
            <h1 className="mt-5 sm:mt-6 text-[2rem] sm:text-[2.75rem] lg:text-[3.35rem] font-extrabold text-navy leading-[1.12] tracking-tight text-balance">
              Career Launchpad Sessions
            </h1>
            <p className="mt-4 sm:mt-5 text-[16px] sm:text-lg text-slate-500 leading-relaxed max-w-2xl mx-auto">
              Free live sessions every week — practical, no-fluff guidance for
              engineering students and freshers navigating the leap from college
              to corporate IT life.
            </p>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
